'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intermediateTransitionProps = exports.wrapperStyle = exports.stageStyle = exports.itemStyles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _animation = require('./animation');

var intermediateTransitionProps = function intermediateTransitionProps(condition, duration) {
  return condition ? { fadeoutAnimationProcessing: true, style: { transition: 'transform 0ms ease-out' } } : { style: { transition: 'transform ' + duration + 'ms ease-out' } };
};

var itemStyles = function itemStyles(i, state, animationProps) {
  var fadeOutOffset = animationProps.fadeOutOffset;
  var itemWidth = state.itemWidth,
      duration = state.duration;


  return (0, _animation.isAnimatedItem)(i, animationProps) ? { transform: 'translateX(' + fadeOutOffset + 'px)', animationDuration: duration + 'ms', width: itemWidth + 'px' } : { width: itemWidth + 'px' };
};

var stageStyle = function stageStyle(style, translate3d) {
  return _extends({}, style, { transform: 'translate3d(' + translate3d + 'px, 0, 0)' });
};
var wrapperStyle = function wrapperStyle(_ref) {
  var paddingLeft = _ref.paddingLeft,
      paddingRight = _ref.paddingRight;

  return { paddingLeft: paddingLeft + 'px', paddingRight: paddingRight + 'px' };
};

exports.itemStyles = itemStyles;
exports.stageStyle = stageStyle;
exports.wrapperStyle = wrapperStyle;
exports.intermediateTransitionProps = intermediateTransitionProps;